import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { Input, Layer } from "../../../components";
import FloatButton from "../../../components/UI/Button/FloatButton";
import DefaultContainer from "../../../components/UI/Container/DefaultContainer";
import HeaderNavigate from "../../../components/UI/Header/HeaderNavigate";
import { IC } from "../../../resources/Assets";
import { PostApi1915 } from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";
import { sha256 } from "js-sha256";
import { _CHECK, _O } from "../../../modules/utils";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";

const PasswordChange = () => {
  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const [msgState, setMsgState] = useState("default");
  const [errTarget, setErrTarget] = useState();

  const messageLayerData = {
    complete: {
      headerIcon: IC.check.ICON_PURPLE_CHECK,
      title: "비밀번호 변경이 완료되었습니다",
      desc: [""],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
            _O.OpenMenu("/mp/myInfo/view");
          },
          text: "확인",
        },
      ],
    },
    failed: {
      headerIcon: "",
      title: "잘못된 비밀번호 입니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    chkOldPw: {
      headerIcon: "",
      title: "현재 비밀번호가 일치하지 않습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    emptyNewPw: {
      headerIcon: "",
      title: "새 비밀번호가 입력되지 않았습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    chkNewPw: {
      headerIcon: "",
      title: "비밀번호가 일치하지 않습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    chkPw: {
      headerIcon: "",
      title: "비밀번호 형식에 문제가 있습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    dupPw: {
      headerIcon: "",
      title: ["기존 비밀번호를", <br />, "새 비밀번호로 사용하실 수 없습니다."],
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
  };

  const request1915 = (oldPassword, newPassword) => {
    PostApi1915(
      userinfo,
      cfg,
      phonecfg,
      userinfo.userId,
      oldPassword,
      newPassword
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          switch (res.result) {
            case 0:
              setMsgState("complete");
              setViewMsgLayer(true);
              setInputs({
                oldPassword: "",
                newPassword1: "",
                newPassword2: "",
              });
              break;
            case 1:
              setMsgState("failed");
              setViewMsgLayer(true);
              break;
            case 2:
              // handleAlert("확인", "현재비밀번호가 맞지 않습나다.");
              setMsgState("chkOldPw");
              setErrTarget("oldPw");
              setViewMsgLayer(true);
              break;
            case 3:
              handleAlert("확인", "비밀번호 변경에 실패했습니다.");
              break;
            default:
              handleAlert("확인", "비밀번호 변경에 실패했습니다.");
              break;
          }

          // 저장 후 팝업 닫고 하단 페이지  새로고침
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveNewPassword = () => {
    if (oldPassword.trim().length === 0) {
      // handleAlert("확인", "현재비밀번호를 입력해 주세요.");
      setMsgState("chkOldPw");
      setErrTarget("oldPw");
      setViewMsgLayer(true);
    } else if (!newPassword1 || newPassword1 == "") {
      setMsgState("emptyNewPw");
      setErrTarget("newPw");
      setViewMsgLayer(true);
    } else if (newPassword1 !== newPassword2) {
      // handleAlert("확인", "새 비밀번호를 확인해 주세요.");
      setMsgState("chkNewPw");
      setErrTarget("newPw");
      setViewMsgLayer(true);
    } else if (!_CHECK.PwdCheck(newPassword1)) {
      // handleAlert(
      //   "확인",
      //   "비밀번호는 영어소문자, 숫자 5자 이상으로 구성되어야 합니다."
      // );

      setMsgState("chkPw");
      setErrTarget("pw");
      setViewMsgLayer(true);
    } else if (oldPassword === newPassword1) { 
      setMsgState("dupPw");
      setErrTarget("newPw");
      setViewMsgLayer(true);
    } else {
      let newPass = sha256(userinfo.userId + "eocs" + newPassword1);
      let oldPass = sha256(userinfo.userId + "eocs" + oldPassword);
      request1915(oldPass, newPass);
    }
  };

  return (
    <Fragment>
      <DefaultContainer>
        <HeaderNavigate
          leftIcon={{
            imgSrc: IC.etc.ICON_CHEVRON_LEFT,
            action: () => window.history.back(),
          }}
          headerTitle="비밀번호 변경"
        />

        <ContentsBody>
          <ContentsTitle>
            변경할 비밀번호를 <br /> 입력해주세요
          </ContentsTitle>

          <ContentBody>
            <Input
              state={errTarget === "oldPw" ? "error" : "default"}
              title_view={true}
              title="현재 비밀번호"
              input_view={true}
              input_type="password"
              input_pattern=""
              input_disable={false}
              input_placeholder="비밀번호를 입력해주세요"
              input_defaultValue={oldPassword}
              input_onChange={e => {
                maxLengthCheck(20, e);
                // inputOnChange(e.target.value, "name");
                setOldPassword(e.target.value);
              }}
              button_view={false}
            />
            <Input
              state={
                errTarget === "newPw" || errTarget === "pw"
                  ? "error"
                  : "default"
              }
              title_view={true}
              title="새 비밀번호"
              input_view={true}
              input_type="password"
              input_pattern=""
              input_disable={false}
              input_placeholder="영어 소문자, 숫자 5자 이상"
              input_defaultValue={newPassword1}
              input_onChange={e => {
                maxLengthCheck(20, e);
                // inputOnChange(e.target.value, "name");
                setNewPassword1(e.target.value);
              }}
              button_view={false}
            />
            <Input
              state={
                errTarget === "newPw" || errTarget === "pw"
                  ? "error"
                  : "default"
              }
              title_view={true}
              title="비밀번호 확인"
              input_view={true}
              input_type="password"
              input_pattern=""
              input_disable={false}
              input_placeholder="영어 소문자, 숫자 5자 이상"
              input_defaultValue={newPassword2}
              input_onChange={e => {
                maxLengthCheck(20, e);
                // inputOnChange(e.target.value, "name");
                setNewPassword2(e.target.value);
              }}
              button_view={false}
            />
          </ContentBody>
        </ContentsBody>
        <FloatButton
          severity="primary"
          disable="off"
          padding={true}
          bottomMenu={false}
          event={() => {
            // alert("1");
            // setViewMsgLayer(!viewMsgLayer);
            saveNewPassword();
          }}
          text="변경하기"
        />
      </DefaultContainer>

      {viewMsgLayer && (
        <Layer
          headerIcon={messageLayerData[msgState].headerIcon}
          title={messageLayerData[msgState].title}
          desc={messageLayerData[msgState].desc}
          ps={messageLayerData[msgState].ps}
          button={messageLayerData[msgState].button}
        />
      )}
    </Fragment>
  );
};

const ContentsBody = styled.div`
  width: 100vw;
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 32px;
  padding: 40px 20px 24px;
  /* background-color: black; */
`;

const ContentsTitle = styled.div`
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.48px;
  text-align: left;
  color: #333;
`;

const ContentBody = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding: 0;
`;

const Content = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
`;

const ContentTitle = styled.div`
  height: 22px;
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

const ContentInput = styled.input`
  height: 52px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 6px;
  border: solid 1px #ff6259;
  background-color: #fff;
  box-sizing: border-box;
`;

export default PasswordChange;
